<!--
  - Copyright (c) 2020. Minerva Networks.
  - All rights reserved.
  -->

<template lang="html">
  <section class="MyMenu">
    <div style="display: flex;">
      <span class="MyMenu__login" @click="login()" v-if="!me.registered">{{$t('SIGN_IN')}}</span>
      <!--<span class="MyMenu__login" style="margin-left: 5px;" @click="()=>{ $router.push('register') }" v-if="!me.registered">{{$t('Register')}}</span>-->
    </div>
    <div class="MyMenu__avatar" @click="displayMe(true)" v-if="me.registered" :style="avatarStyle">
      <template v-if="!me.avatar || displayAvatar === false">
        {{ me.first ? me.first[0] : '?' }}{{ me.last ? me.last[0] : '?' }}
      </template>
    </div>
  </section>
</template>

<script lang="js">
import { mapMutations, mapState } from 'vuex';

export default {
  name: 'myMenu',
  props: [],
  mounted() {
  },
  components: {},
  data() {
    return {};
  },
  methods: {
    ...mapMutations([
      'redirectToIP',
      'displayMe',
    ]),
    login() {
      this.redirectToIP({
        registered: true,
        ls: this.$ls,
      });
    },
  },
  computed: {
    ...mapState(['me', 'baseUrl', 'displayAvatar']),
    avatarStyle() {
      if (this.displayAvatar) {
        return { backgroundImage: `url(${this.me.avatar})` };
      }
      return '';
    },
  },
};
</script>
